export default {
  analyze: {
    is_reservation: 0,
    reservation: {
      frequency: 2,
      memo: null,
      monthly_settings: 1,
      monthly_last_day_flag: 0,
      last_date: null,
      repeat_count: 1,
      weekly_settings: 0,
      publish_setting: 0, // 0:private 1:public
      dashboard_flag: 0 // 0:非表示 1:表示
    },
    condition: {
      type: null,
      type_mode: 0,
      term: {
        base_setting: 1, // (1:期間から 2:曜日から 3:日付直指定)
        has_base_time: 0,
        has_target: 0,
        search_term_base: {
          from: null,
          to: null
        },
        search_term_base_weeks: [],
        search_term_base_box: [],
        search_term_base_time: {
          from: null,
          to: null
        },
        search_term_base_dates: [],
        search_term_target: {
          from: null,
          to: null
        },
        search_term_newitem: null,
        search_term_month: null
      },
      age_reference: 0,
      product: {
        code_pattern: 2,
        contract_flag: 2,
        has_target: 0,
        has_together: 0,
        count_together: 0,
        item_base: {
          analyze: {
            mode: 'category',
            is_all: 0,
            code: [],
            file_name: '',
            file: [],
            group: [],
            category: {
              noSubmit: true,
              code: []
            },
            category_group: {
              noSubmit: true,
              id: []
            },
            product_attribute: {
              noSubmit: true,
              code: []
            },
            freeword: '',
            freeword_code: [],
            code_exclude: [],
            product_area_code: null
          }
        },
        item_base_code: [],
        item_target: {
          analyze: {
            mode: 'category',
            is_all: 0,
            code: [],
            name: [],
            file_name: '',
            file: [],
            group: [],
            category: {
              noSubmit: true,
              code: []
            },
            category_group: {
              noSubmit: true,
              id: []
            },
            product_attribute: {
              noSubmit: true,
              code: []
            },
            freeword: '',
            freeword_code: [],
            code_exclude: [],
            product_area_code: null
          }
        },
        item_target_code: [],
        item_together: {
          conditions: []
        }
      },
      shop: {
        has_shop_target: 0,
        shop_base: {
          analyze: {
            mode: 'category',
            is_all: 0,
            group: [],
            category: [],
            code: [],
            name: [],
            file_name: '',
            file: [],
            freeword: '',
            freeword_code: [],
            code_status: [1, 2, 3],
            code_exclude: [],
            shop_area_code: null
          }
        },
        shop_base_code: []
      },
      member: {
        mode: 'group',
        mask_flag: 0,
        member_ids: {
          analyze: {
            code: [],
            file_name: '',
            file: [],
            group: []
          }
        },
        gender: [],
        age_target: 0,
        age_code: [],
        decile: {
          from: null,
          to: null
        },
        rank: {
          from: null, //  1
          to: null //  10
        },
        rank_month: null,
        quantity: {
          from: null,
          to: null
        },
        amount: {
          from: null,
          to: null
        },
        visit: {
          from: null,
          to: null
        },
        gross: {
          from: null,
          to: null
        },
        card: [],
        payment: 0,
        basket_price: {
          from: null,
          to: null
        },
        non_member: null,
        non_member_only: 0
      },
      price_range: {
        from: 0,
        to: 0
      },
      price_range_step: 100,
      groupby: [],
      aggregate: [],
      total_display: [],
      zero_data_flag: 0,
      graph_setting: 0,
      publish_setting: 0,
      member_group_id: null,
      member_group_name: null,
      member_group_tag: null,
      member_group_memo: null
    }
  },
  togetherCondition: {
    code: [],
    analyze: {
      mode: 'category',
      is_all: 0,
      code: [],
      file_name: '',
      file: [],
      group: [],
      category: {
        noSubmit: true,
        code: []
      },
      category_group: {
        noSubmit: true,
        id: []
      },
      product_attribute: {
        noSubmit: true,
        code: []
      },
      freeword: '',
      freeword_code: [],
      code_exclude: []
    }
  }
}
